module.exports = __webpack_public_path__ + "img/6e5566b5b794f22618256a6f07e3bcbe.jpg";